import { Dialog, DialogContent, DialogTitle, Select, FormControl, InputLabel, MenuItem, Grid, DialogActions, Button, IconButton } from "@mui/material";
import { useMemo, useState } from "react";
import { TFiltrosDetalheIntegracao } from "..";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import SelectEstabelecimentos from "../../../../../../components/SelectsSimpleApiQuery/SelectEstabelecimentos";
import { TEstabelecimento } from "../../../../../../types/api/financeiro/estabelecimentos";
import CloseIcon from '@mui/icons-material/Close';

export default function FiltrosDetalheIntegracao({
    open,
    tipo,
    filtros,
    onClose,
    onSubmit
}: FiltrosDetalheIntegracaoProps) {

    const [status, setStatus] = useState<string[]>(filtros?.status_contem || [])
    const [respostas, setRespostas] = useState<string[]>(filtros?.resposta_contem || [])
    const [estabelecimento, setEstabelecimento] = useState<TEstabelecimento[] | null>(filtros?.estabelecimento || null)
    const [ocorrencias, setOcorrencias] = useState<string[]>(filtros?.ocorrencias || [])
    const selectStatusValues = useMemo(() => {
        return [
            { value: 'Aguardando finalização' },
            { value: 'Finalizado' },
            { value: 'Conflito encontrado' }
        ]
    }, [])

    const selectOcorrenciasValues = useMemo(() => {
        return [
            { value: 'Liquidação' },
            { value: 'Entrada confirmada' },
        ]
    }, [])

    const selectRespostasValues = useMemo(() => {
        if (tipo === 'CNAB240') {
            return [
                { value: 'Título encontrado' },
                { value: 'Título não encontrado' },
            ]
        }
        if (tipo !== 'RedeEEFI') {
            return [
                { value: 'Título não encontrado' },
                { value: 'Título encontrado pelo NSU' },
                { value: 'Múltiplos títulos encontrados pelo NSU' },
                { value: 'Título encontrado pela data de emissão e valor' },
                { value: 'Múltiplos títulos encontrados pela data de emissão e valor' },
                { value: 'Estabelecimento não cadastrado' },
            ]
        }
        return []
    }, [tipo])

    const handleSubmit = () => {
        const filtros = {
            status_contem: status.length > 0 ? status : null,
            resposta_contem: respostas.length > 0 ? respostas : null,
            estabelecimento: estabelecimento ? estabelecimento : null,
            ocorrencias: ocorrencias.length > 0 ? ocorrencias : null
        }
        onSubmit(filtros)
        onClose()
    }

    const handleLimpar = () => {
        setStatus([])
        setRespostas([])
        setEstabelecimento(null)
        setOcorrencias([])
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            maxWidth="sm"
            fullWidth>
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Filtros</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid size={{xs: 6}} mt={1}>
                        <FormControl fullWidth>
                            <InputLabel>Status</InputLabel>
                            <Select
                                label="Status"
                                value={status}
                                multiple
                                onChange={(e) => setStatus(e.target.value as string[])}
                            >
                                {selectStatusValues.map((item) => <MenuItem key={item.value} value={item.value}>{item.value}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    {
                        tipo !== 'RedeEEFI' &&
                        <Grid size={{xs: 6}} mt={1}>
                            <FormControl fullWidth>
                                <InputLabel>Resposta</InputLabel>
                                <Select
                                    label="Resposta"
                                    multiple
                                    value={respostas}
                                    onChange={(e) => setRespostas(e.target.value as string[])}
                                >
                                    {selectRespostasValues.map((item) => <MenuItem key={item.value} value={item.value}>{item.value}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                    }
                    {
                        tipo !== 'CNAB240' &&
                        <Grid size={{xs: 6}} mt={1}>
                            <SelectEstabelecimentos
                                multiple
                                inputLabel="Estabelecimentos"
                                value={estabelecimento as TEstabelecimento[]}
                                onChangeValue={(value) => setEstabelecimento(value)}
                            />
                        </Grid>
                    }
                    {
                        tipo === 'CNAB240' &&
                         <Grid size={{xs: 6}} mt={1}>
                             <FormControl fullWidth>
                                 <InputLabel>Ocorrencias</InputLabel>
                                 <Select
                                     label="Ocorrencias"
                                     value={ocorrencias}
                                     onChange={(e) => setOcorrencias(e.target.value as string[])}
                                     multiple
                                 >
                                     {selectOcorrenciasValues.map((item) => <MenuItem key={item.value} value={item.value}>{item.value}</MenuItem>)}
                                 </Select>
                             </FormControl>
                         </Grid>
                    }
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleLimpar}>Limpar</Button>
                <Button variant="contained" onClick={handleSubmit}>Aplicar</Button>
            </DialogActions>
        </Dialog >
    )
}

interface FiltrosDetalheIntegracaoProps {
    open: boolean;
    tipo: string;
    filtros: TFiltrosDetalheIntegracao | null;
    onClose: () => void;
    onSubmit: (filtros: TFiltrosDetalheIntegracao) => void;
}
